<template>
  <list137 />
</template>


<script>
import List137 from "@/views/boards/single-page/137/List137.vue";

export default {
  components: { List137 }
}
</script>

<style scoped></style>
